import { racquetOutcome } from '../../../shared/racquetOutcome.mjs'
export default function RacquetOutcome({ state, t, teamName }) {
  const outcome = racquetOutcome(state)
  return (
    <div className="rp-outcome">
      <h2>{t(outcome.kind)}</h2>
      {outcome.winner &&
        state.teams.map((team) => (
          <p key={team.id}>
            <small>
              {t(team.id === outcome.winner ? 'winner' : 'runnerUp')}
            </small>
            <strong>{teamName(team)}</strong>
          </p>
        ))}
      {state.segments.length > 0 && (
        <p className="rp-outcome-total">
          {outcome.wins.join('–')} {t(outcome.unit)}
        </p>
      )}
    </div>
  )
}
